import { render } from "./ViewsErrors403.vue?vue&type=template&id=0f20e600"
import script from "./ViewsErrors403.vue?vue&type=script&lang=js"
export * from "./ViewsErrors403.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__